<template>
    <footer class="app-footer">
        Profi-Bank.org &copy; {{ year }} <a href="http://professional-group.org" target="_blank">SIIB Professional Group</a>
        <span class="float-right"><a href="http://prosperity.one" target="_blank">Consortium Prosperity SE</a></span>
    </footer>
</template>

<script>
  export default {
      name: 'footer',
      data () {
          return {
              year: new Date().getFullYear()
          }
      }
  }
</script>



// WEBPACK FOOTER //
// Footer.vue?f76d796a